import type { AxiosError } from 'axios';
import { isAxiosError } from 'axios';

export interface ApiError {
  error: string;
  message: string | string[];
  statusCode: 400;
}

export type ApiErrorResponse = AxiosError<ApiError>;

export const isCarUnavailableError = (error: unknown): error is ApiErrorResponse =>
  isAxiosError<ApiError>(error) && error.response?.data?.error === 'CAR_UNAVAILABLE';
